<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Commission</span>
      </div>
      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Currency">
            <el-select v-model="query.currency">
                <el-option value="gbp" label="GBP"></el-option>
                <el-option value="eur" label="EUR"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="Search Date">
          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="getIncome()"
            >Query</el-button
          >
          <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button>
          <el-button icon="el-icon-download" type="danger" @click="PDFReport()">PDF</el-button>
        </el-form-item>
      </el-form>

      <el-tag v-if="dataTable.length > 0">Incomes in the scope: {{ query.currency.toUpperCase() + " " + Sum}}</el-tag>

      <data-tables 
        v-loading="loading" 
        :data="dataTable" 
        border 
        :page-size="20"
        :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
        <el-table-column prop="customer_code" label="Introducer Code" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="customer_name" label="Customer Name" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="amount" label="Amount" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="currency" label="Currency" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="date" label="Approve Date" header-align="center" align="center"> </el-table-column>

      </data-tables>
    </el-card>
  </div>
</template>

<script>
import { currentDateTime, dateFormat, currencyFormat } from '@/utils'
import { getIncome, reportIncomeExcel, reportIncomePDF } from "@/api/introducer";
export default {
  data() {
    return {
      loading: false,
      dataTable: [],
      dateSearch: "",
      Sum: 0,
      query: {
        from: "",
        to: "",
        currency: "gbp",
      },
    };
  },
  methods: {
    getIncome() {
      this.loading = true;
      this.SelectDate();
      getIncome(this.$route.params.customer_uid, this.query).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataTable = data['list']
          this.Sum = currencyFormat(data['sum'])
        }
      });
    },
    SelectDate(){
      this.query.from = dateFormat(this.dateSearch[0], "YYYY-MM-DD") || currentDateTime("YYYY-MM-DD")
      this.query.to = dateFormat(this.dateSearch[1], "YYYY-MM-DD") || currentDateTime("YYYY-MM-DD")
    },
    ExcelReport(){
      this.SelectDate();
      reportIncomeExcel(this.$route.params.customer_uid, this.query);
    },
    PDFReport(){
      this.SelectDate();
      reportIncomePDF(this.$route.params.customer_uid, this.query);
    }
  },
};
</script>

<style>
</style>